import { create } from 'zustand';

const useOobCodeState = create((set) => ({
    oobCode: '',
    setoobCode: (newoobCode) => set(() => ({ oobCode: newoobCode })),
}));

export default useOobCodeState;